import { ListOptionState } from "../shared/UiStates/TriStateCheckbox";

export type ConsentState = {
  selectedPurposes: number[];
};

export class PurposeModel {
  optedIn: boolean;
  shouldDisplayTitle = true;
  id: number;
  name: string;
  legalDescription: string;
  shouldDisplayLegalDescription = true;
  public constructor(init?: Partial<PurposeModel>) {
    Object.assign(this, init);
  }
}

export class StackModel {
  public constructor(init?: Partial<StackModel>) {
    Object.assign(this, init);
  }

  id: number;
  name: string;
  Purposes: PurposeModel[];
  ToggleState?: ListOptionState;
  shouldDisplayDescription = true;
  isStackEnabled = true;
  TotalPurposes(): number {
    return this.Purposes.length;
  }

  TotalOptedInPurposes(): number {
    return this.Purposes.filter((p) => p.optedIn).length;
  }
}

export type FooterModel = {
  rejectButton: string;
  acceptButton: string;
};

export type PreferenceModel = {
  title: string;
  message: string;
};

export const stackPurposesMapping: { [stackId: number]: number[] } = {
  1000: [1],
  42: [2, 3, 4, 5, 6, 7, 8, 9, 10],
  1001: [1000],
};

export const GetAllOptionIds = (): number[] => {
  const options: number[] = [];

  stackPurposesMapping[stackIds.STORAGE].forEach((op) => options.push(op));
  stackPurposesMapping[stackIds.PERSONALISED_AD].forEach((op) => options.push(op));
  stackPurposesMapping[stackIds.THIRD_PARTY].forEach((op) => options.push(op));

  return options;
};

export const stackIds = {
  STORAGE: 1000,
  PERSONALISED_AD: 42,
  THIRD_PARTY: 1001,
};
